import { Injectable, inject } from '@angular/core';
import { ApiService } from '@core/services';
import { Observable } from 'rxjs';
import { WorkPlaceGroup } from '../models';
import { BussinesService } from '../../public/services';
import { Cookies } from 'typescript-cookie';
import { NumberValue } from 'd3-scale';

@Injectable({
  providedIn: 'root',
})
export class WorkplaceGroupService {
  private apiService = inject(ApiService);
  private bussinesService = inject(BussinesService);

  storeWorkplace(data: WorkPlaceGroup, businessId: number) {
    const url = `workPlaceGroup?name=${encodeURIComponent(
      data.name
    )}&description=${encodeURIComponent(
      data.description
    )}&business_id=${businessId}`;
    return this.apiService.store(url, undefined);
  }

  deleteWorkplace(id: number) {
    return this.apiService.delete(`workPlaceGroup`, id);
  }

  getWorkplaces(bussinessId?: number): Observable<any> {
    if (bussinessId) {
      return this.apiService.getAll(
        `workPlaceGroup?business_id=${bussinessId}`
      );
    } else {
      const business = Cookies.get(`bussinesId`);
      return this.apiService.getAll(`workPlaceGroup?business_id=${business}`);
    }
  }

  getWorkplace(id: number): Observable<any> {
    return this.apiService.getById(`workPlaceGroup`, id);
  }

  updateWorkplace(data: WorkPlaceGroup, id: number, business_id?: number) {
    return this.apiService.update(
      `workPlaceGroup/${encodeURIComponent(id)}?name=${encodeURIComponent(
        data.name
      )}&description=${encodeURIComponent(
        data.description
      )}&business_id=${business_id}`,
      '',
      id
    );
  }

  getWorkplaceByFloor(idFloor: number) {
    return this.apiService.getAll(`workplace?floorid=${idFloor}`);
  }
}
